

















import { Component, Prop, Vue } from 'vue-property-decorator';
import AuthenticatedNav from '@classes/AuthenticatedNav';
import InitialsBadge from '@components/header/navigation/initials-badge.vue';

@Component({ components: { InitialsBadge } })
export default class MobileNavUserHeader extends Vue {
	@Prop()
	private nav!: AuthenticatedNav;

	get name(): string {
		if (this.nav && this.nav.fullName) {
			return this.nav.fullName;
		} else {
			return 'Your Account';
		}
	}

	get isMultipleEntities(): boolean {
		return this.nav && this.nav.multipleInvestmentEntities;
	}
}
